import React, { useEffect } from "react";
import "./App.css";
import AppRouting from "./app-routing";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./store/reducers";
import promiseMiddleware from "redux-promise";
import "./Styles/hover.css";
import rtl from "jss-rtl";
import { create } from "jss";
import {
  StylesProvider,
  jssPreset,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import MessengerCustomerChat from "react-messenger-customer-chat";
import FixedLinks from "./Components/FixedLinks/FixedLinks";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createTheme({
  direction: "rtl",
});

const createStoreWithMW = applyMiddleware(promiseMiddleware)(createStore);
const store = createStoreWithMW(rootReducer);

function App() {
  useEffect(() => {
    const hidePreloader = () => {
      const preloader = document.getElementById("preloader-active");
      if (preloader) {
        preloader.style.transition = "0.5s";
        preloader.style.opacity = "0";
        preloader.style.pointerEvents = "none";
        setTimeout(() => {
          preloader.style.display = "none";
        }, 500);
      }
      document.body.style.overflowX = "hidden";
    };
    const t = setTimeout(hidePreloader, 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <Provider store={store}>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
          <FixedLinks />
          <AppRouting />
          <MessengerCustomerChat
            pageId="104085248909373"
            appId="801709641232523"
          />
        </ThemeProvider>
      </StylesProvider>
    </Provider>
  );
}

export default App;
